package com.dualremotetest.web

import com.dualremotetest.TankMatch
import com.dualremotetest.format
import com.dualremotetest.keyLabel
import kotlinx.browser.document
import org.w3c.dom.HTMLElement

/** Live input and timing diagnostics (pause or settings menu → DIAGNOSTICS), a shorter TankUi.DiagnosticsPanel. */
object DiagnosticsOverlay {
    private val panel get() = document.getElementById("diag") as HTMLElement?
    private var frame = 0

    fun update(match: TankMatch, audio: WebTankAudio) {
        val el = panel ?: return
        if (!match.showDiagnostics) {
            if (el.style.display != "none") el.style.display = "none"
            return
        }
        el.style.display = "block"
        if (frame++ % 10 != 0) return
        val f = match.frames
        val lines = mutableListOf(
            "DIAGNOSTICS  (${match.phase.name.lowercase()})",
            "stage ${match.stage} · t %.1f s · enemies ${match.enemies.size}/${match.maxAlive} · left ${match.toSpawn} · killed ${match.killed}"
                .format(match.stageFrame / 60.0),
            "mode ${match.moveMode.label.lowercase()} · smoothing ${if (match.input.smoothingMs == 0L) "off" else "${match.input.smoothingMs} ms"}",
        )
        val p = match.input.p1
        val tank = match.players[0]
        lines += "P1 ${p.channel?.label ?: "-"}${if (p.connected) "" else " DISCONNECTED"} · ${tank.state.name.lowercase()}"
        lines += "held ${p.heldDirections().joinToString("+") { keyLabel(it) }.ifEmpty { "-" }} · down ${p.downs} up ${p.ups}"
        lines += "fire ${p.okPresses} shot ${tank.shots} refused ${tank.shotsRefused}"
        lines += "lives ${tank.lives} stars ${tank.stars} pickups ${tank.pickups} deaths ${tank.deaths}"
        lines += "frame %.1f ms · avg %.1f · max %.0f · steps ${match.stepsLastFrame}".format(f.recentMs, f.avgMs, f.maxMs)
        lines += "frames >50 ms ${f.over50} · >100 ms ${f.over100}"
        lines += "audio req ${audio.requested} skipped ${audio.skipped}"
        match.lastReportPath?.let { lines += "report: $it" }
        lines += "frame time ≠ button-to-screen latency"
        el.textContent = lines.joinToString("\n")
    }
}
